import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/servicestack': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M88 216c81.7 10.2 273.7 102.3 304 232h-392c99.5-8.1 184.5-137 88-232zM120 64c102.8 15.5 335.3 167.9 376 384h-96c-26.3-126.7-150.7-216.7-233.6-250.4 1.3-49.7-14.1-98-46.4-133.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/servicestack.js
// module id = 1010
// module chunks = 0